import * as zod from 'zod';

import Entity from './entity';
import { aclValue } from './common';

export const flowAclSchema = zod.object({
  'flow:start': aclValue.optional(),
});

const actorConfigSchema = zod.object({
  id: zod.number(),
  type: zod.string(), // e.g. "AGREEMENT_PARTICIPANT"
});

const actionGroupConfigSchema = zod.object({
  actor: actorConfigSchema,
});

const blockConfigSchema = zod.object({
  blockIndex: zod.number(),
});

const baseNodeSchema = zod.object({
  created: zod.string(),
  createdTime: zod.string(),
  createdTs: zod.number(),
  updated: zod.string(),
  updatedTime: zod.string(),
  updatedTs: zod.number(),
  id: zod.number(),
  agreementFlow: zod.object({
    id: zod.number(),
  }),
  key: zod.string(),
  status: zod.string(),
  statusTime: zod.string(),
});

const actionGroupNodeSchema = baseNodeSchema.extend({
  parent: zod.object({
    id: zod.number(),
  }),
  childNodes: zod.array(zod.any()).default([]),
  config: actionGroupConfigSchema,
});

const blockNodeSchema = baseNodeSchema.extend({
  parent: zod.null(),
  childNodes: zod.array(actionGroupNodeSchema),
  config: blockConfigSchema,
});

const PendingStateFlow = Entity.extend({
  created: zod.string().nullable().optional(),
  createdTs: zod.number().nullable().optional(),
  updated: zod.string().nullable().optional(),
  updatedTs: zod.number().nullable().optional(),
  id: zod.number().nullable().optional(),
  key: zod.string().nullable().optional(),
  status: zod.string().nullable().optional(),
  statusTime: zod.string().nullable().optional(),
  childNodes: zod.array(blockNodeSchema).nullable().optional(),
  config: zod.object({}).nullable().optional(),
  acl: flowAclSchema.nullish().optional(),
  runningBlock: zod.object({}).nullable().optional(),
}).describe('pendingStateFlow');

export default PendingStateFlow;
